import React from 'react'
import { colors } from '../../../styles/vars/colors.style'

const Route2a = ({
  width = 340,
  height = 276,
  stroke = colors.light,
  opacity = 1,
  offset = 0,
  pathLength = 525,
  responsive = true,
  forwardRef = null,
}) => {
  const svgAttributes = responsive
    ? {}
    : {
        width,
        height,
      }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 340 276"
      focusable="false"
      role="img"
      fill="none"
      {...svgAttributes}
    >
      <path
        strokeWidth="3"
        stroke={stroke}
        opacity={opacity}
        ref={forwardRef}
        strokeDashoffset={offset * pathLength}
        strokeDasharray={pathLength}
        d="M339,50.5001C303.5,2.5 247.5,-10.3823 189,11.0008C114.938,38.072 97,137.001 79,212.001C64.6,272.001 14.3333,277.667 -9,273.001"
      />
    </svg>
  )
}

export default Route2a
